import { Reducer } from "redux";

import { ServiceProviderDetailsActionDispatchTypes } from "../constants/Authorization";
import { ServiceProviderDetailsDispatchTypes } from "../models/DispatchTypes/Authorization";
import { ServiceProviderDetailsResponse } from "../models/Api/Authorization";

const initialState: ServiceProviderDetailsResponse = {
    loading: false,
    response: {
      referralId: -1,
      referralServiceProviderId: -1,
      serviceProviderId: "",
      extension: "",
      phone: "",
      fax: "",
      streetName1: null,
      streetName2: null,
      providerCity: null,
      providerCounty: null,
      providerState: null,
      zipCode: null,
      providerAddress: "",
      parentCompany: 0,
      ahcccsId: "",
      medicareId: "",
      contractEffectiveFrom: "",
      contractEffectiveTo: "",
      userCreated: null,
      providerName: "",
      providerNpi: "",
      taxId: "",
      symplrId: 0,
      serviceProviderUid: "",
      country: "",
      email: "",
      plexisOfficeId: 0,
      providerId: 0,
      reimbursementTypeId: null,
      reimbursementTypeName: null,
      isOutOfNetwork: false,
    },
  error: null,
};

const PutServiceProviderDetailsReducer: Reducer<
ServiceProviderDetailsResponse,
ServiceProviderDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceProviderDetailsActionDispatchTypes.PUT_SERVICE_PROVIDER_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceProviderDetailsActionDispatchTypes.PUT_SERVICE_PROVIDER_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceProviderDetailsActionDispatchTypes.PUT_SERVICE_PROVIDER_DETAILS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case ServiceProviderDetailsActionDispatchTypes.PUT_SERVICE_PROVIDER_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PutServiceProviderDetailsReducer;
